/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { dublicateAlert, errorAlert, yup, PopupTextField } from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import { Box, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import PopupPassword from './PopupPassword';
import { errorAlertMsg } from '../Shared/helpers';

const PopupUserAdmin = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  theme,
  editPassword,
  block,
  company,
}: any) => {
  const [saving, setSaving] = useState(false);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [blockUser, setBlockUser] = useState(false);
  const [openPass, setOpenPass] = useState(false);
  const [isAccountant, setisAccountant] = useState(false);

  const { register, handleSubmit, errors, reset } = useForm(
    isNew ? yup.addUserResolver : undefined
  );
  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);

  useEffect(() => {
    if (row && row._id) {
      setBlockUser(row.block);
      setisAccountant(row.isAccountant);
    }
  }, [open]);

  const onClosePass = () => setOpenPass(false);
  const onSubmit = async (data: any) => {
    if (user.isSuperAdmin !== true) {
      if (row.isSuperAdmin === true || row.isSuperAdmin === 'true') {
        await errorAlertMsg(setAlrt, "You can't change this account");
        return;
      }
    }
    setSaving(true);
    const name = data?.name;
    const phone = data?.phone;
    const variables: any = {
      _id: row && row._id ? row._id : undefined, // is it new or edit
      name,
      phone,
      isAccountant,
      verified: true,
    };
    try {
      await editAction({ variables });
      onFormClose();
    } catch (error) {
      onError(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      reset();
      console.log(error);
    }
  };

  const onBlockUser = () => {
    const variables = {
      _id: row._id,
      block: !blockUser,
    };
    block({ variables });
  };

  const onFormClose = () => {
    reset();
    setisAccountant(false);
    setSaving(false);
    onClose();
  };

  const onHandleSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const title = isRTL
    ? isNew
      ? 'اضافة مستخدم'
      : 'تعديل بيانات مستخدم'
    : isNew
    ? 'New User'
    : 'Edit User';
  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onFormClose}
      title={title}
      onSubmit={onHandleSubmit}
      theme={theme}
      alrt={alrt}
      mb={50}
      saving={saving}
      maxWidth="lg"
    >
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <PopupTextField
                required
                name="name"
                label={words.name}
                register={register}
                errors={errors}
                fullWidth
                row={row}
              />
            </Grid>
            <Grid item xs={6}>
              <PopupTextField
                name="phone"
                label={words.phoneNumber}
                register={register}
                errors={errors}
                fullWidth
                row={row}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAccountant}
                    onChange={() => setisAccountant(!isAccountant)}
                    name="bold"
                    color="primary"
                  />
                }
                label={isRTL ? 'محاسب' : 'Accountant'}
              />
            </Grid>
          </Grid>
          <Box
            display="flex"
            style={{
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 20,
            }}
          ></Box>
          <Box
            display="flex"
            style={{ alignItems: 'center', justifyContent: 'flex-end' }}
          >
            {!isNew && (
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenPass(true)}
                style={{ marginLeft: 10, marginRight: 10 }}
              >
                {isRTL ? 'تغيير كلمة المرور' : 'Change Password'}
              </Button>
            )}
            {!row.isSuperAdmin && !isNew && (
              <Button
                color={blockUser ? 'secondary' : 'primary'}
                onClick={onBlockUser}
                variant="outlined"
              >
                {blockUser
                  ? isRTL
                    ? 'تفعيل الحساب'
                    : 'Unblock user'
                  : isRTL
                  ? 'تعطيل الحساب'
                  : 'Block user'}
              </Button>
            )}
          </Box>
        </Grid>
        <PopupPassword
          open={openPass}
          onClose={onClosePass}
          row={row}
          editPassword={editPassword}
          theme={theme}
        ></PopupPassword>
      </Grid>
    </PopupLayout>
  );
};

export default PopupUserAdmin;
